import { render, staticRenderFns } from "./ExamWrapper.vue?vue&type=template&id=13044cb8&scoped=true&"
import script from "./ExamWrapper.vue?vue&type=script&lang=js&"
export * from "./ExamWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ExamWrapper.vue?vue&type=style&index=0&id=13044cb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13044cb8",
  null
  
)

export default component.exports